<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="overflow-hidden rounded">
      <div class="overflow-auto px-2">
        <div class="flex justify-between">
          <div class="font-bold title mb-2">
            辞退の理由を記入し、保存ボタンを押してください。
          </div>
        </div>

        <div class="text-gray-700 font-bold my-3">{{ name }} さん</div>

        <textarea
          :rows="3"
          class="border-gray-300 rounded w-full mt-3"
          v-model="text"
        ></textarea>

        <div class="flex" v-if="!loading">
          <PrimaryButton text="キャンセル" @click="closed()" class="m-3 bg-blue-100 text-blue-700 w-full">
          </PrimaryButton>
          <PrimaryButton text="保存" @click="save()" class="m-3 w-full">
          </PrimaryButton>
        </div>
        <div v-else class="text-lg font-bold text-center title animate-pulse">
          保存中...
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as dialogs from '@libs/dialogs'
import * as requestPostManager from '@managers/requestPostManager'
import * as taskRequestManager from '@managers/taskRequestManager'


export default {
  components: {
    Modal,
    PrimaryButton,
  },

  //
  props: ['open', 'id', 'requestNo', 'status', 'name'],

  data() {
    return {
      // ローディング
      loading: false,
      // 理由
      text: ''
    }
  },

  methods: {
    /**
     * 初期にリセット
     */
    closed() {
      this.text = ''
      this.loading = false
      this.$emit('close')
    },

    /**
     * 保存
     */
    async save() {
      this.loading = true

      const res = await requestPostManager.upDateOneForInterviews(this, this.requestNo, { declineReason: this.text })
      this.loading = false

      if (!res) {
        alert('再度試してください。')
        return
      } else {
        // メインタスクが未完了の場合
        if (this.status == 'open') {
          const log = await dialogs.showConfirmDialog('保存完了、タスクを完了にしますか？', '辞退の理由を保存しました。\r\nメインタスクは未完了です。完了にしますか？また、未完了のサブタスクは削除いたします。よろしいでしょうか？', '完了にする', 'しない')
          if (log === 'YES') {
            this.loading = true
            // 未完了のサブタスクは削除する
            const sub = await taskRequestManager.deleteOpenSub(this, this.id)
            if (!sub) {
              alert('サブタスクの削除に失敗しました。再度保存を押してください。')
              this.loading = false
              return
            }
            // メインタスク完了
            await requestPostManager.upDateOneForInterviews(this, this.requestNo, { status: 'done' })
            this.loading = false
            await dialogs.showSuccessDialog('処理完了', '一覧に遷移します。')
          }
        } else {
          await dialogs.showSuccessDialog('保存完了', '辞退の理由を保存しました。一覧に遷移します。')
        }
      }
      this.$emit('saveReason', this.text)
      this.closed()
    },
  }
}
</script>
<style scoped>
  .main-height {
    height: 85vh;
  }

  .title {
    color: #7b77b9;
  }

  /* 入力欄を自動調整 */
  textarea {
    field-sizing: content !important;
  }
</style>